import React from 'react';
import { Icon } from '@ok/okd';
import './TipMessage.less';

const typIcon = {
  error: 'okds-fail-circle-fill',
  warn: 'okds-warning-circle-fill',
  info: 'okds-information-circle-fill',
  success: 'okds-success-circle-fill',
};

/**
 *
 * @param title 提示的信息
 * @param onClose 关闭回调
 * @param closeFlag 是否显示关闭按钮
 * @param operationText 右侧操作文案
 * @param operationClick 操作回调
 * @param type 类型 ：error/warn/tip/success
 * @returns {*}
 * @constructor
 */
export default function TipMessage({
  title,
  onClose,
  closeFlag,
  operationText,
  operationClick,
  type,
  textList,
  textListNewLine,
}) {
  return (
    <div className={`tip-container ${type}-message`}>
      <Icon className={`tip-icon ${typIcon[type]}`} />
      {title && (
        <span
          className={`tip-message ${
            !operationText || operationText.length === 0 ? 'no-operation' : ''
          }`}
        >
          {title}
        </span>
      )}
      {textList &&
        textList.length > 0 &&
        textList.map((item, index) => {
          return (
            <span
              key={index}
              className={`tip-message ${
                !operationText || operationText.length === 0
                  ? 'no-operation'
                  : ''
              }`}
            >
              {item}
            </span>
          );
        })}

      {textListNewLine &&
        textListNewLine.length > 0 &&
        textListNewLine.map((item) => {
          return <div className="tip-message">{item}</div>;
        })}

      <span
        className={`tip-operation ${closeFlag ? '' : 'no-close'}`}
        onClick={operationClick}
      >
        {operationText}
      </span>
      {closeFlag && (
        <span className="icon-click-con" onClick={onClose}>
          <Icon className="okds-close tip-close" />
        </span>
      )}
    </div>
  );
}
TipMessage.type = {
  error: 'error',
  warn: 'warn',
  info: 'info',
  success: 'success',
};
